export default __webpack_public_path__ + "static/media/opensealogo.1f5996d8.svg";